import { render } from "./RequestForm.vue?vue&type=template&id=be2bacf6&scoped=true"
import script from "./RequestForm.vue?vue&type=script&lang=js"
export * from "./RequestForm.vue?vue&type=script&lang=js"

import "./RequestForm.vue?vue&type=style&index=0&id=be2bacf6&scoped=true&lang=css"

import exportComponent from "/builds/infinitesoftsolutions/fishing-license/fishing-license-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be2bacf6"]])

export default __exports__